<form [formGroup]="formGroup">
  @if (
    !$request().actualReleaseDate && (canUserEditActualReleaseDate$() | async)
  ) {
    <tui-accordion size="s">
      <button tuiAccordion>
        <span class="text-xs text-orange-400">{{
          'request_form.common.supplier.actual_release_date_block.actual_date_differs'
            | translate
        }}</span>
      </button>
      <tui-expand class="mt-3">
        <ng-container *tuiItem>
          <div class="x-input-label mt-0">
            {{
              'request_form.common.supplier.actual_release_date_block.actual_release_date'
                | translate
            }}
          </div>
          <div>
            <tui-textfield
              xHyphenedStringTuiDateTransformer
              tuiTextfieldSize="m"
            >
              <input
                tuiInputDate
                type="date"
                [formControlName]="FormFields.ActualReleaseDate"
                [placeholder]="
                  'request_form.common.supplier.actual_release_date_block.actual_release_date_placeholder'
                    | translate
                "
              />
              <tui-calendar *tuiDropdown />
            </tui-textfield>
            @if (
              actualReleaseDateField.touched &&
              actualReleaseDateField.errors?.['required']
            ) {
              <tui-error
                [error]="
                  'request_form.common.supplier.actual_release_date_block.error_required'
                    | translate
                "
              ></tui-error>
            }
          </div>
          <div class="flex justify-end mt-3">
            <button
              tuiButton
              type="button"
              size="s"
              (click)="setActualReleaseDate$.next()"
            >
              {{
                'request_form.common.supplier.actual_release_date_block.button_save'
                  | translate
              }}
            </button>
          </div>
        </ng-container>
      </tui-expand>
    </tui-accordion>
  } @else if ($request().actualReleaseDate) {
    <div class="x-input-label">
      {{
        'request_form.common.supplier.actual_release_date_block.actual_release_date'
          | translate
      }}
    </div>
    <div class="flex flex-row">
      <tui-textfield
        xHyphenedStringTuiDateTransformer
        tuiTextfieldSize="m"
        [tuiTextfieldCleaner]="true"
        class="grow"
      >
        <input
          tuiInputDate
          type="date"
          [formControlName]="FormFields.ActualReleaseDate"
          placeholder="{{
            'request_form.common.supplier.actual_release_date_block.actual_release_date_placeholder'
              | translate
          }}"
        />
        <tui-calendar *tuiDropdown />
      </tui-textfield>
      @if (canUserEditActualReleaseDate$() | async) {
        <button
          class="block self-center ml-5"
          tuiButton
          type="button"
          size="s"
          (click)="changeActualReleaseDate$.next()"
        >
          {{
            'request_form.common.supplier.actual_release_date_block.button_change'
              | translate
          }}
        </button>
      }
    </div>
  }
</form>
